import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

// Local replacement for react-storefront/Row.
// A full-width block with bottom margin of theme.spacing(2).
const useStyles = makeStyles(theme => ({
  root: {
    margin: `0 0 ${theme.spacing(2)}px 0`,
  },
}))

export default function Row({ children, classes, ...others }) {
  classes = useStyles({ classes })
  return (
    <div className={classes.root} {...others}>
      {children}
    </div>
  )
}
